import { IRequest } from '@r1-frontend/shared/types/IRequest';

export type { IPv6State, ResponseDto } from './dto/ResponseDto';
export { EIPv6Status } from './dto/ResponseDto';


/**
 * Получение текущего статуса ipv6
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/Services%20Settings/55055880127f77c7f2c885d22b73f77f
 * */
export const getIpv6Status = (terminalResource: number): IRequest => ({
    uri: '/v1/services-settings/get-ipv6-status',
    method: 'POST',
    withAuth: true,
    withProvider: true,
    body: JSON.stringify({
        trId: terminalResource,
    }),
});
